import React, { useCallback } from "react";
import Label from "../ui-components/Label";
import roleTypesSettings from "./roleTypesSettings";
import getStringInitials from "../utils/getStringInitials";
import _ from "lodash";

const ServiceConfiguratorBlockVisibility = ({
  roleTypes,
  newData,
  setNewData,
  blockKey = "r_perm",
  label = "Visibility",
  editable = true,
}) => {

  const getRoleVisibility = useCallback(
    (name) => {

      if (blockKey === 'hidden_question') {
        return !newData?.[blockKey].includes(`role_type_${name}`)
      }

      // the following cases are for r_perm, that we are not using anymore in Genius Lab
      // if (newData?.[blockKey].indexOf("public") >= 0) {
      //   return true;
      // }
      //
      // if (newData?.[blockKey].indexOf(`role_type_${name}`) >= 0) {
      //   return true;
      // }
      //
      // return false;
    },
    [newData, blockKey]
  );

  const setRoleVisibility = useCallback(
    (name) => {
      // if (newData?.[blockKey].indexOf("public") >= 0) {
      //   setNewData({
      //     ...newData,
      //     [blockKey]: [
      //       ...roleTypes
      //         .filter((r) => r.name !== name)
      //         .map((r) => `role_type_${r.name}`),
      //       "admin",
      //     ],
      //   });
      //   return;
      // }

      if (newData?.[blockKey].indexOf(`role_type_${name}`) >= 0) {
        setNewData({
          ...newData,
          [blockKey]: [
            ...newData[blockKey].filter((s) => s !== `role_type_${name}`),
          ],
        });
        return;
      }

      setNewData({
        ...newData,
        [blockKey]: [...newData[blockKey], `role_type_${name}`],
      });
    },
    [newData, setNewData, blockKey]
  );

  const groupedRoles = roleTypes.reduce(
    (acc, {name, business}) => {
      if (!(business.name in acc))
        acc[business.name] = [];
      return {...acc, [business.name]: [...acc[business.name], name]}
    },
    {}
  );

  return (
    <div className="flex w-full items-center justify-between gap-6 mb-4">
      <div className="flex-1">
        <Label disabled={!editable}>{label}</Label>
      </div>
      <div className="flex flex-col gap-2">
        {Object.entries(groupedRoles).map(([business, roles], idx, arr) => (
          <div key={idx} className="flex flex-col gap-1 items-end">
            {arr.length > 1 && (
              <p className="text-xxs">
                {_.capitalize(business)}
              </p>
            )}
            <div className="flex">
              {roles.map((name) => (
                <div
                  onClick={() => {
                    if (!editable) {
                      return;
                    }
                    setRoleVisibility(name);
                  }}
                  style={{ opacity: getRoleVisibility(name) ? 1 : 0.4 }}
                  key={name}
                  className={`flex ${editable ? 'cursor-pointer': 'cursor-not-allowed'} ml-1 justify-center items-center w-7 h-7 rounded-full ${roleTypesSettings?.[name]?.color ?? 'bg-gray-400'}`}
                >
                  <p className="text-white text-xs font-bold">
                    {roleTypesSettings?.[name]?.abbr ?? getStringInitials(name)}
                  </p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceConfiguratorBlockVisibility;
